export type AppVersionInfo = {
  version: string;
  build: string; // e.g. git commit count
  sha: string;   // short git sha
  builtAt: string;
};

export const appVersionInfo: AppVersionInfo = {
  version: __APP_VERSION__,
  build: __APP_BUILD_COUNTER__,
  sha: __APP_GIT_SHA__,
  builtAt: __APP_BUILD_TIME__,
};

export function formatAppVersionShort(info: AppVersionInfo = appVersionInfo): string {
  const parts: string[] = [];
  parts.push(`v${info.version}`);
  if (info.build) parts.push(`#${info.build}`);
  if (info.sha) parts.push(info.sha);
  return parts.join(" · ");
}

export function formatAppVersionLong(info: AppVersionInfo = appVersionInfo): string {
  const parts: string[] = [];
  parts.push(`UI-Version: v${info.version}`);
  if (info.build) parts.push(`Build: ${info.build}`);
  if (info.sha) parts.push(`Commit: ${info.sha}`);
  // display-format: technische Versionszeile für den Support, Zeitstempel bewusst unverändert.
  if (info.builtAt) parts.push(`Zeit: ${info.builtAt}`);
  return parts.join(" | ");
}

/** Lokaler Desktop-Info-Dialog: dieselbe geladene UI-Version wie im InfoModal.
 * Kein Abruf von version.json, kein IPC und keine Anmeldedaten.
 * Vertrag: meta[name="m1member-version"].content enthält formatAppVersionShort().
 */
export function publishAppVersionMetadata(): void {
  let metadata = document.querySelector<HTMLMetaElement>('meta[name="m1member-version"]');
  if (!metadata) {
    metadata = document.createElement("meta");
    metadata.name = "m1member-version";
    document.head.appendChild(metadata);
  }
  metadata.content = formatAppVersionShort();
}

